import { Divider } from "@mui/material";
import useDeviceType from "hooks/useDeviceType";
import ItemDetailsLayout from "library/Layouts/DetailsLayout/ItemDetailsLayout";
import { PropTypes } from "prop-types";

const OrderDetailsLayout = ({
  statusBarSection,
  paymentSection,
  briefInfoSection,
  extraInfoSection,
  dropsListSection,
  cancelOrderSection,
  priceSection,
  controlsSection,
  modals,
}) => {
  const { isDesktop } = useDeviceType();

  return (
    <>
      <ItemDetailsLayout
        statusBarSection={statusBarSection}
        briefInfoSection={
          <div className="d-flex flex-column col-12 px-0 gap-4">
            {paymentSection && (
              <>
                <div className="d-flex flex-lg-row flex-column-reverse align-items-lg-center align-items-stretch mt-3 gap-4">
                  {paymentSection}
                </div>

                <Divider className="my-3" />
              </>
            )}

            {briefInfoSection}
          </div>
        }
        extraInfoSection={extraInfoSection}
        listSection={
          <>
            {dropsListSection}

            {!isDesktop && <div className="mb-4">{cancelOrderSection}</div>}
          </>
        }
        controlsSection={
          <>
            {isDesktop && cancelOrderSection}

            <div className="d-flex flex-column align-items-end justify-content-between gap-4 col px-0">
              <div className="text-right text-fs-14 text-fw-semibold text-truncate">{priceSection}</div>

              <div className="d-flex flex-md-row flex-column-reverse justify-content-md-end justify-content-center align-items-end gap-3 col px-0">
                {controlsSection}
              </div>
            </div>
          </>
        }
      />

      {modals}
    </>
  );
};

OrderDetailsLayout.defaultProps = {
  paymentSection: null,
  cancelOrderSection: null,
  priceSection: null,
  modals: null,
};

OrderDetailsLayout.propTypes = {
  statusBarSection: PropTypes.node.isRequired,
  paymentSection: PropTypes.node,
  briefInfoSection: PropTypes.node.isRequired,
  extraInfoSection: PropTypes.node.isRequired,
  dropsListSection: PropTypes.node.isRequired,
  cancelOrderSection: PropTypes.node,
  priceSection: PropTypes.node,
  controlsSection: PropTypes.node.isRequired,
  modals: PropTypes.node,
};

export default OrderDetailsLayout;
